// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__31byT","footer":"ReportModalFilter_footer__1ymqT"};